import Head from "next/head";
import { make as AnomaliesPage } from "../../src/info/AnomaliesPage.bs.js";

export default function AnomaliesRoute({ charms, charmOdds }) {
  return (
    <>
      <Head>
        <title>TFT Set 13 Anomalies Info</title>
      </Head>
      <AnomaliesPage charms={charms} charmOdds={charmOdds} />
    </>
  );
}
